import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import UserManagement from '../components/UserManagement';

const AdminHub: React.FC = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={0} aria-label="admin hub tabs">
          <Tab label="User Management" />
        </Tabs>
      </Box>
      <UserManagement />
    </Box>
  );
};

export default AdminHub;
